import { SelectionChangedEvent } from 'ag-grid-community';

export interface CustomSelectAllEvent extends SelectionChangedEvent {
  type: 'selectionChanged';
  readonly customType: 'selectAllChanged';
  selectAll: boolean;
  selectedNodes: null;
  serverSideState: null;
}

export interface CustomResetSelectAllEvent extends SelectionChangedEvent {
  type: 'selectionChanged';
  readonly customType: 'selectAllReset';
  resetSelectAll: boolean;
  selectedNodes: null;
  serverSideState: null;
}

export type CustomSelectionChangedEvent = CustomSelectAllEvent | CustomResetSelectAllEvent;

export function isCustomSelectionChangedEvent(
  event: CustomSelectionChangedEvent | SelectionChangedEvent,
): event is CustomSelectionChangedEvent {
  return typeof (<CustomSelectionChangedEvent>event).customType === 'string';
}
